/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkQuestion {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkQuestion.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkQuestion>): WellArchitectedFrameworkQuestion {
        let obj = Object.assign(new WellArchitectedFrameworkQuestion(), model);
        WellArchitectedFrameworkQuestion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkQuestion>): WellArchitectedFrameworkQuestion {
        if (!model) return null;
        return WellArchitectedFrameworkQuestion.newInstance(<WellArchitectedFrameworkQuestion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkQuestion) {
        if (!obj) return;

        models.WellArchitectedFrameworkQuestion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkQuestion): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkQuestion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_on === "string") {
            this.created_on = new Date(<string><any>this.created_on);
        }
        if (typeof this.updated_on === "string") {
            this.updated_on = new Date(<string><any>this.updated_on);
        }
        if (this.best_practices) {
            for (let val of this.best_practices) {
                models.RecordIdentity.fixupPrototype(val);
            }
        }
    }

    /**
     * Well Architected Question created on
     */
    created_on: Date;

    /**
     * Well Architected Question updated on
     */
    updated_on: Date;

    /**
     * ID of the framework associated with the question
     */
    framework_id: string;

    /**
     * ID of the pillar associated with the question
     */
    pillar_id: string;

    /**
     * ID for the particular question
     */
    question_id: string;

    /**
     * Id of question
     */
    hyperscaler_question_id: string;

    /**
     * Question
     */
    question: string;

    /**
     * Description for the question
     */
    description: string;

    best_practices: Array<models.RecordIdentity>;

}
